import React from 'react';
import './ActionFooter.css';

interface ActionFooterProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  className?: string;
  innerClassName?: string;
  position?: 'fixed' | 'sticky';
}

export const ActionFooter: React.FC<ActionFooterProps> = ({
  children,
  className,
  innerClassName,
  position = 'sticky',
  ...props
}) => {
  const classes = ['action-footer', `action-footer--${position}`, className]
    .filter(Boolean)
    .join(' ');

  const innerClasses = ['action-footer__inner', innerClassName]
    .filter(Boolean)
    .join(' ');

  return (
    <footer className={classes} {...props}>
      <div className={innerClasses}>{children}</div>
    </footer>
  );
};
